var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDaideePlanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4957_4183)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#0F0073"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M32.0506 18.0076C32.9571 18.9141 33.8636 19.8206 33.8636 19.8206C35.0847 18.5995 35.0909 17.3847 33.882 16.1759C32.9755 15.2694 32.3714 14.665 32.3745 14.0576C30.848 15.5839 30.8419 16.7988 32.0506 18.0076Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M32.316 25.5988C32.3191 24.9913 32.9293 24.3808 33.8454 23.465C35.0665 22.2439 35.0726 21.029 33.8638 19.8203C33.8638 19.8203 32.9481 20.7361 32.0324 21.6519C30.8112 22.873 30.805 24.0879 32.316 25.5988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7264 7.4097C25.1189 7.4128 24.5146 6.80844 23.6081 5.90192C22.3993 4.6932 21.1844 4.6994 19.9634 5.92047C19.9634 5.92047 20.8699 6.82698 21.7764 7.73353C22.9852 8.94222 24.2 8.93605 25.7264 7.4097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M18.1319 7.75207C19.0477 6.83628 19.9635 5.92047 19.9635 5.92047C18.7548 4.71177 17.5399 4.71794 16.3188 5.93901C15.403 6.85483 14.7925 7.46536 14.1851 7.46847C15.6959 8.97934 16.9108 8.97317 18.1319 7.75207Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M32.3745 14.0579C33.9007 12.5316 33.9069 11.3167 32.0939 9.50362L30.2809 7.69056C28.4678 5.8775 27.2529 5.88367 25.7266 7.41003C26.334 7.40696 27.2538 8.30024 28.4492 9.52216L30.2623 11.3353C31.4581 12.5568 32.3776 13.4505 32.3745 14.0579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.73353 21.7711C6.82698 20.8646 5.92047 19.958 5.92047 19.958C4.6994 21.1791 4.6932 22.394 5.90192 23.6027C6.80844 24.5092 7.4128 25.1136 7.4097 25.721C8.93605 24.1947 8.94222 22.9798 7.73353 21.7711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M7.46845 14.1797C7.46538 14.7872 6.85484 15.3977 5.93902 16.3135C4.71796 17.5346 4.71175 18.7495 5.92048 19.9582C5.92048 19.9582 6.83626 19.0423 7.75208 18.1266C8.97315 16.9055 8.97935 15.6906 7.46845 14.1797Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0576 32.369C14.665 32.3659 15.2694 32.9703 16.1759 33.8768C17.3847 35.0857 18.5995 35.0795 19.8206 33.8584C19.8206 33.8584 18.9141 32.9519 18.0076 32.0451C16.7988 30.8365 15.5839 30.8427 14.0576 32.369Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M21.652 32.0269C20.7361 32.9426 19.8203 33.8586 19.8203 33.8586C21.029 35.0672 22.2439 35.061 23.465 33.8399C24.3808 32.9242 24.9914 32.3136 25.5988 32.3106C24.0879 30.7997 22.873 30.8058 21.652 32.0269Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M7.40955 25.7212C5.8832 27.2475 5.877 28.4624 7.69005 30.2755L9.50311 32.0884C11.3162 33.9017 12.5311 33.8955 14.0574 32.369C13.45 32.372 12.5302 31.4788 11.3347 30.2569L9.52169 28.4439C8.32585 27.2223 7.40645 26.3286 7.40955 25.7212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.185 7.46858C12.6741 5.95771 11.4592 5.96388 9.62761 7.79548L7.79597 9.62712C5.96437 11.4587 5.9582 12.6736 7.46907 14.1845C7.47218 13.5771 8.37487 12.6482 9.60903 11.4402L11.4407 9.60854C12.6745 8.40022 13.5776 7.47165 14.185 7.46858Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5996 32.3149C27.1105 33.8258 28.3254 33.8197 30.157 31.988L31.9887 30.1565C33.8201 28.3249 33.8266 27.11 32.3157 25.5991C32.3126 26.2066 31.4099 27.1355 30.1756 28.3434L28.3439 30.1751C27.1101 31.3834 26.2071 32.3119 25.5996 32.3149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 14.0026H19.3337C20.7773 14.0026 22.0369 14.2635 23.1125 14.7826C24.1881 15.3044 25.0227 16.0509 25.6136 17.0246C26.2045 17.9984 26.5 19.1349 26.5 20.4367C26.5 22.5935 25.8598 24.2285 24.5769 25.3366C23.2965 26.4472 21.5341 27 19.2948 27H14.5V14V14.0026ZM19.5747 23.7661C20.5337 23.7661 21.2698 23.4691 21.7855 22.8724C22.3013 22.2784 22.5605 21.4647 22.5605 20.4367C22.5605 19.5198 22.2987 18.7578 21.7778 18.1482C21.2568 17.5386 20.5389 17.2364 19.6317 17.2364H18.3618V23.7636H19.5747V23.7661Z",
    fill: "#EEEEEF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4957_4183"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaideePlanIcon);
export default __webpack_public_path__ + "static/media/daidee-plan-icon.2377fb769bd76dca2010b3255b821c9c.svg";
export { ForwardRef as ReactComponent };